// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1ZYDZ","title":"styles_title__30U3e"};